// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f174def6","245":"4c6f4898","292":"f6c95146","363":"9dfa1919","504":"205e78a4"}[chunkId] + ".chunk.js";
};